var _a, _b;
import { PAYMENT_IMGS, PaymentMethodsImgEnum } from "./PaymentMethodImgEnum";
export var PaymentMethodsEnum;
(function (PaymentMethodsEnum) {
    PaymentMethodsEnum["CARD"] = "credit-card";
    PaymentMethodsEnum["SUBSCRIPTION"] = "subscription";
    PaymentMethodsEnum["TRANSFER"] = "transfer";
    PaymentMethodsEnum["TRANSFER_PSE"] = "transfer-pse";
    PaymentMethodsEnum["TRANSFER_SAFETYPAY"] = "transfer-safetypay";
    PaymentMethodsEnum["TRANSFER_ETPAY"] = "transfer-etpay";
    PaymentMethodsEnum["TRANSFER_SPEI"] = "transfer-spei";
    PaymentMethodsEnum["TRANSFER_SUBSCRIPTION"] = "transfer-subscription";
    PaymentMethodsEnum["CASH"] = "cash";
    PaymentMethodsEnum["CARD_ASYNC"] = "card-async";
    PaymentMethodsEnum["CARD_DYNAMIC"] = "card-dynamic";
    PaymentMethodsEnum["CARD_SUBSCRIPTION_ASYNC"] = "card-async-subscription";
    PaymentMethodsEnum["CARD_SUBSCRIPTION_DYNAMIC"] = "card-dynamic-subscription";
    PaymentMethodsEnum["CARD_BANK_ACCENDO"] = "card-bank-accendo";
})(PaymentMethodsEnum || (PaymentMethodsEnum = {}));
export var ACTIVATION_METHODS = (_a = {},
    _a[PaymentMethodsEnum.CARD] = "singlePayment",
    _a[PaymentMethodsEnum.SUBSCRIPTION] = "recurringPayment",
    _a[PaymentMethodsEnum.TRANSFER] = "transferPayment",
    _a[PaymentMethodsEnum.TRANSFER_PSE] = "transferPayment",
    _a[PaymentMethodsEnum.TRANSFER_SAFETYPAY] = "transferPayment",
    _a[PaymentMethodsEnum.TRANSFER_ETPAY] = "transferPayment",
    _a[PaymentMethodsEnum.TRANSFER_SPEI] = "transferPayment",
    _a[PaymentMethodsEnum.CARD_ASYNC] = "cardAsyncPayment",
    _a[PaymentMethodsEnum.CARD_DYNAMIC] = "cardDynamicPayment",
    _a[PaymentMethodsEnum.CASH] = "cashPayment",
    _a[PaymentMethodsEnum.CARD_SUBSCRIPTION_ASYNC] = "cardSubscriptionAsyncPayment",
    _a[PaymentMethodsEnum.CARD_SUBSCRIPTION_DYNAMIC] = "cardSubscriptionDynamicPayment",
    _a[PaymentMethodsEnum.TRANSFER_SUBSCRIPTION] = "transferSubscriptionPayment",
    _a[PaymentMethodsEnum.CARD_BANK_ACCENDO] = "recurringPayment",
    _a);
export var PAYMENT_METHOD_CONFIG = (_b = {},
    _b[PaymentMethodsEnum.CARD] = {
        description: "itemDescriptions.makePaymentsCard",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        title: "itemTitles.creditCard",
    },
    _b[PaymentMethodsEnum.CASH] = {
        description: "itemDescriptions.makePaymentsCash",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CASH],
        title: "itemTitles.cash",
    },
    _b[PaymentMethodsEnum.TRANSFER] = {
        description: "itemDescriptions.makePaymentsTransfer",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.TRANSFER],
        title: "itemTitles.transfer",
    },
    _b[PaymentMethodsEnum.TRANSFER_SUBSCRIPTION] = {
        description: "itemDescriptions.makePaymentsTransfer",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.TRANSFER],
        title: "itemTitles.transfer",
    },
    _b[PaymentMethodsEnum.SUBSCRIPTION] = {
        description: "itemDescriptions.makePaymentsCardSubscription",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        title: "itemTitles.cardSubscription",
    },
    _b[PaymentMethodsEnum.CARD_ASYNC] = {
        description: "itemDescriptions.makePaymentsCardAsync",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        title: "itemTitles.cardAsync",
    },
    _b[PaymentMethodsEnum.CARD_SUBSCRIPTION_ASYNC] = {
        description: "itemDescriptions.makePaymentsCardSubscriptionAsync",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        title: "itemTitles.cardSubscriptionAsync",
    },
    _b[PaymentMethodsEnum.CARD_DYNAMIC] = {
        description: "itemDescriptions.makePaymentsCardDynamic",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        title: "itemTitles.cardDynamic",
    },
    _b[PaymentMethodsEnum.CARD_SUBSCRIPTION_DYNAMIC] = {
        description: "itemDescriptions.makePaymentsCardSubscriptionDynamic",
        logo: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        title: "itemTitles.cardSubscriptionDynamic",
    },
    _b);
